import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {AccountNumberMask, DescriptiveText, LoadingSpinner, Row, TextInput, SectionTitle} from '../../../shared';
import debug from 'debug';
import moment from 'moment';
import {formatter} from '../../../shared/utils/utils';
import useSWR from 'swr';
import axiosInstance from '../../../shared/utils/axios';
const log = debug('circleblack:investor:AccountInfo');

const AccountInfo = ({containerID}) => {
  const {data: account, error: accountError} = useSWR(
    containerID && `/containers/${containerID}/accounts`,
    url => axiosInstance.get(url).then(res => res.data[0])
  );
  const {data: advisors, error: advisorsError} = useSWR(
    account && `/accounts/${account.id}/advisors`,
    url => axiosInstance.get(url).then(res => res.data)
  );
  const {data: positionsCount, error: positionsCountError} = useSWR(containerID && `containers/${containerID}/positions/count`);

  const [error, setError] = useState();
  log('accountInfo');

  useEffect(() => {
    if (accountError?.response?.data || advisorsError?.response?.data || positionsCountError?.response?.data) {
      setError(accountError?.response?.data.error || advisorsError?.response?.data.error
        || positionsCountError?.response?.data.error);
    }
  }, [accountError, advisorsError, positionsCountError]);

  if (!account || !advisors) {
    if (error) {
      return <>{error.msg || 'Failed to load data from API.'}</>;
    }
    return <LoadingSpinner/>;
  }

  return <>
    <DescriptiveText font={'ProximaSemibold'}
                     fontSize={'20px'}
                     alignment={'left'}
                     width={'fill'}>
      {account.name}
    </DescriptiveText>
    <DescriptiveText font={'ProximaLight'}
                     fontSize={'14px'}
                     alignment={'left'}
                     width={'fill'}>
      <AccountNumberMask number={account.number}
                         institution={account.institution}
                         institutionName={account.institution.name}/>
    </DescriptiveText>
    <Row justifySubRow={'space between'} margin={'0 0 5px'}>
      <div>
        <DescriptiveText font={'ProximaSemibold'}
                         fontSize={'20px'}
                         alignment={'left'}
                         width={'160px'}
                         margin={'5px 5px 0'}>
          {formatter('currency')(account.balance)}
        </DescriptiveText>
        <DescriptiveText font={'ProximaLight'}
                         fontSize={'10px'}
                         alignment={'left'}
                         width={'160px'}>
          As Of {moment(account.asOfDate).format('M/D/YY')}
        </DescriptiveText>
      </div>
      <TextInput type={'text'}
                 placeholder={''}
                 dataPoint={{name: 'holdings', value: positionsCount}}
                 title={'# of Holdings'}
                 width={'120px'}
                 readOnly={true}/>
    </Row>
    <Row justifySubRow={'space between'} margin={'0 0 5px'}>
      <TextInput type={'text'}
                 placeholder={''}
                 dataPoint={{name: 'accounts', value: account.institution?.name}}
                 title={'Institution'}
                 width={'160px'}
                 readOnly={true}/>
      <TextInput type={'text'}
                 placeholder={''}
                 dataPoint={{name: 'clients', value: account.type}}
                 title={'Type'}
                 width={'120px'}
                 readOnly={true}/>
    </Row>
    {advisors.length
      ? <>
        <SectionTitle title={'Managed By:'}/>
        {advisors.map(advisor => <Row key={advisor.id} justifySubRow={'space between'} margin={'0 0 5px'}>
          <div>
            <DescriptiveText font={'ProximaSemibold'}
                             fontSize={'16px'}
                             alignment={'left'}
                             ellipsisOverflow={{popoverContent: advisor.displayName}}
                             width={'160px'}>
              {advisor.displayName}:
            </DescriptiveText>
            <DescriptiveText font={'ProximaRegular'}
                             fontSize={'14px'}
                             alignment={'left'}
                             ellipsisOverflow={{popoverContent: advisor.email}}
                             width={'160px'}>
              {advisor.email}
            </DescriptiveText>
          </div>
          <div>
            <DescriptiveText font={'ProximaRegular'}
                             fontSize={'12px'}
                             alignment={'left'}
                             width={'120px'}>
              Managed Since:
            </DescriptiveText>
            <DescriptiveText font={'ProximaRegular'}
                             fontSize={'12px'}
                             alignment={'left'}
                             width={'120px'}>
              {formatter('date')(advisor.managedSince)}
            </DescriptiveText>
          </div>
        </Row>)}
      </>
      : null
    }
  </>;
};

export default AccountInfo;

AccountInfo.propTypes = {
  containerID: PropTypes.number.isRequired,
};
